import { Box } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

import { Image } from 'core/elements';
import { getDomainUrl } from 'core/utils';

export const style = {
  width: '56px',
  height: '56px',
};

interface IProps {
  url: string;
  alt: string;
  sx?: SxProps;
}

export const PartImage = ({ url, alt, sx }: IProps) => {
  return (
    <Box
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Image src={`${getDomainUrl()}${url}/h/75/w/75/entire/1`} alt={alt} style={style} />
    </Box>
  );
};
